import * as React from 'react';
import { MaskedInput, MaskedInputProps } from 'fronton-react';

type PhoneInputProps = {
  phoneRef: (el: HTMLInputElement | null) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  label: string;
} & Omit<MaskedInputProps, 'mask' | 'label' | 'onChange'>;

/**
 * Поле ввода мобильного номера телефона
 */
export const PhoneInput = ({ onChange, value, phoneRef, label, ...props }: PhoneInputProps) => {
  /**
   * Очистка значения при потере фокуса, если ввод номера не завершен
   */
  const handleOnBlur = (e: React.SyntheticEvent) => {
    if ((e.target as HTMLInputElement)?.value.includes('x')) {
      onChange(e as React.ChangeEvent<HTMLInputElement>, '');
    }
  };

  return (
    <MaskedInput
      label={label}
      mask="+7 (999) 999-99-99"
      onBlur={handleOnBlur}
      onChange={onChange}
      maskPlaceholder="x"
      ref={phoneRef}
      value={value}
      {...props}
    />
  );
};
